import EditActionSeconds from './EditActionSeconds'
import { connect } from 'react-redux'
import { setBetMs } from '../reducers/betMs'


const mapStateToProps = (state) => ({
    label: 'scommessa',
    seconds: Math.round(state.betMs / 1000)
})

const mapDispatchToProps = (dispatch) => ({
    onSubmit: (seconds) => dispatch(setBetMs(seconds * 1000))
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditActionSeconds)


// WEBPACK FOOTER //
// ./src/components/EditBetSeconds.js